import * as React from "react";
import { CustomButton, ButtonType, Modal, ModalSize, ModalBody, ModalFooter, TextInput } from "soprasteria-ui-library";
import { IReferralTreatment } from "../../../../models/IReferral";
import { dateTimeToDateString } from "../../../../helpers/DateHelper";
import { formatCurrency } from "../../../../helpers/CurrencyHelper";

interface IReferralTreatmentInfoModal {
    treatment?: IReferralTreatment;
    onFormClose: () => void;
}

export const ReferralTreatmentInfoModal: React.FunctionComponent<IReferralTreatmentInfoModal> = ({ treatment, onFormClose }) => {
    return (
        <Modal id="referral-treatment-info-modal" header="Åtgärdskod" modalSize={ModalSize.large}>
            {
                treatment ?
                    <ModalBody>
                        <TextInput name="dateOfTreatmentReadOnly" label="Datum" defaultValue={dateTimeToDateString(treatment.treatmentDate)} readonly inlineLabel />
                        <TextInput name="carePerformerNameReadonly" label="Behandlare" defaultValue={treatment.carePerformerName} readonly inlineLabel />
                        <TextInput name="treatmentReadOnly" label="Åtgärdskod" defaultValue={`${treatment.treatmentCode} - ${treatment.treatmentCodeDescription}`} readonly inlineLabel />
                        <TextInput name="quantityReadOnly" label="Antal" defaultValue={`${treatment.quantity}`} readonly inlineLabel />
                        <TextInput name="priceReadOnly" label="à-pris" defaultValue={`${formatCurrency(treatment.price)}`} readonly inlineLabel />
                        <TextInput name="totalPriceReadOnly" label="Summa" defaultValue={`${formatCurrency(treatment.quantity * treatment.price)}`} readonly inlineLabel />
                        <TextInput name="statusReadOnly" label="Status" defaultValue={treatment.status} readonly inlineLabel />
                        <TextInput name="motiveReadOnly" label="Motivering" defaultValue={treatment.comment} readonly inlineLabel />
                        {
                            treatment.assessmentComment ?
                                <TextInput name="assessmentCommentReadOnly" label="Kommentar granskning" defaultValue={treatment.assessmentComment} readonly inlineLabel />
                                : null
                        }

                    </ModalBody>
                    : null
            }
            <ModalFooter>
                <CustomButton buttonType={ButtonType.general} buttonText="Stäng" data-dismiss="modal" id="close-referral-treatment-info-modall" onClick={onFormClose} />
            </ModalFooter>
        </Modal >
    )
}